/**
 * @license
 */

import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';

import { UIHeader, UIMasthead, UIJumbo, UIContextnav, UITopnav } from '@api/models';
import * as actionsHeader from '../actions/ui-header/ui-header.actions';
import * as actionsMasthead from '../actions/ui-header/ui-masthead.actions';
import * as actionsJumbo from '../actions/ui-header/ui-jumbo.actions';
import * as actionsTopnav from '../actions/ui-header/ui-topnav.actions';
import * as actionsContextnav from '../actions/ui-header/ui-contextnav.actions';

/**
 * UI state
 */
export interface UIHeaderState {
	header: UIHeader;
	masthead: UIMasthead;
	jumbo: UIJumbo;
	contextnav: UIContextnav;
	topnav: UITopnav;
};

/**
 * Default UI state
 */
// For dummy data
// export const initialState: UIHeaderState = {
// 	header: { background: 'banner.jpg', color: 'green' },
// 	masthead: { hubname: 'Hello World', fullLogo: false },
// 	jumbo: { title: 'Jumbo Title', caption: '', visible: true, variant: 'jumbo-variant-light' },
// 	contextnav: null,
// 	topnav: null
// };

export const initialState: UIHeaderState = {
	header: {
		background: '',
		color: '#f2fbfe'
	},
	masthead: {
		hubname: '',
		fullLogo: true
	},
	jumbo: {
		title: '',
		caption: '',
		visible: false,
		variant: 'jumbo-variant-light'

	},
	contextnav: null,
	topnav: null,
};

export function reducer(state: UIHeaderState = initialState, action: Action): UIHeaderState {

	switch (action.type) {

		// Header -----------------------------------------------------------------------------------
		case actionsHeader.SET_BACKGROUND:
			return {
				...state,
				header: Object.assign({}, state.header, { background: action.payload }),
			};

		case actionsHeader.SET_COLOR:
			return {
				...state,
				header: Object.assign({}, state.header, { color: action.payload }),
			};

		// Masthead --------------------------------------------------------------------------------
		case actionsMasthead.SET_HUBNAME:
			return {
				...state,
				masthead: Object.assign({}, state.masthead, { hubname: action.payload })
			}

		case actionsMasthead.SET_LOGO:
			return {
				...state,
				masthead: Object.assign({}, state.masthead, { fullLogo: false })
			}

		case actionsMasthead.SET_COMBINATION_MARK:
			return {
				...state,
				masthead: Object.assign({}, state.masthead, { fullLogo: true })
			}

		// Jumbo -----------------------------------------------------------------------------------
		case actionsJumbo.SET_TITLE:
			return {
				...state,
				jumbo: Object.assign({}, state.jumbo, { title: action.payload })
			}

		case actionsJumbo.SET_CAPTION:
			return {
				...state,
				jumbo: Object.assign({}, state.jumbo, { caption: action.payload })
			}

		case actionsJumbo.SET_VARIANT:
			return {
				...state,
				jumbo: Object.assign({}, state.jumbo, { variant: action.payload })
			}

		case actionsJumbo.SHOW:
			return {
				...state,
				jumbo: Object.assign({}, state.jumbo, { visible: true })
			}

		case actionsJumbo.HIDE:
			return {
				...state,
				jumbo: Object.assign({}, state.jumbo, { visible: false })
			}

		// Topnav -----------------------------------------------------------------------------------
		case actionsTopnav.SET_TOPNAV:
			return {
				...state,
				topnav: Object.assign({}, state.topnav, { navItems: action.payload })
			}

		// Context -----------------------------------------------------------------------------------
		case actionsContextnav.SET_CONTEXTNAV:
			return {
				...state,
				contextnav: Object.assign({}, state.contextnav, { navItems: action.payload })
			}

		default:
			return state;
	}
};

// Header
export const getHeaderBackground = (state: UIHeaderState) => state.header.background;
export const getHeaderBackgroundColor = (state: UIHeaderState) => state.header.color;

export const getHeaderColor = (state: UIHeaderState) => state.header.color;

// Masthead
export const getMastheadHubname = (state: UIHeaderState) => state.masthead.hubname;
export const getMastheadLogo = (state: UIHeaderState) => state.masthead.fullLogo;

// Jumbo
export const getJumboTitle = (state: UIHeaderState) => state.jumbo.title;
export const getJumboCaption = (state: UIHeaderState) => state.jumbo.caption;
export const getJumboVariant = (state: UIHeaderState) => state.jumbo.variant;
export const showJumbo = (state: UIHeaderState) => state.jumbo.visible;

// Topnav
export const getTopnavItems = (state: UIHeaderState) => state.topnav.navItems;

// Contextnav
export const getContextnavItems = (state: UIHeaderState) => state.contextnav.navItems


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/reducers/ui-header.reducer.ts